import { Button, Input } from '@heroui/react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import React, { useState } from 'react';
import Script from 'next/script';
import { EmailShareButton, WhatsappShareButton } from 'react-share';
import { getShareUrl } from '@/app/utils/get-share-url';

export default function ShareModalContent() {
  const [isCopied, setIsCopied] = useState(false);
  const offerLink = getShareUrl();
  const t = useTranslations('shareOffer');
  const shareMessage = t('message');
  const shareSubject = t('subject');
  const teamsUrl = `https://teams.microsoft.com/share?href=${encodeURIComponent(
    offerLink
  )}&msgText=${encodeURIComponent(shareMessage)}&referrer=localhost`;

  const subtitleStyles = 'font-semibold text-lg leading-8';
  const buttonStyles =
    'text-base leading-6.5 px-4 py-[6px] rounded-lg border border-black';
  const teamsLink = (styles: string) => {
    return (
      <a
        data-testid="email-share-button"
        href={teamsUrl}
        className={`${styles} ${buttonStyles}`}
        target="_blank"
      >
        {t('teams')}
      </a>
    );
  };
  const handleCopy = () => {
    navigator.clipboard.writeText(offerLink);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 5000);
  };

  return (
    <div>
      <Script src="https://teams.microsoft.com/share/launcher.js" async defer />
      <p data-testid="share-title" className={`md:pt-4 py-4 ${subtitleStyles}`}>
        {t('linkTitle')}
      </p>
      <div className="flex flex-col md:flex-row md:min-h-15 mb-8 items-center">
        <Input
          data-testid="share-link"
          classNames={{
            inputWrapper: 'bg-transparent border min-h-[50px] md:min-h-[59px]',
            input: 'truncate !text-[var(--color-text-subtle)]',
          }}
          size="lg"
          radius="sm"
          className="md:pr-6 leading-6.5 w-full"
          value={offerLink}
        ></Input>
        <Button
          data-testid="share-link-button"
          className="btn-primary btn-padded !inline-flex h-full mt-4 md:mt-0 w-full md:w-auto"
          onPress={handleCopy}
          endContent={
            isCopied && (
              <Image
                src="/images/checkmark.svg"
                alt="checkbox"
                width={18.75}
                height={13.5}
                className="min-h-[13.5px] min-w-[18.75px] ml-2.5"
              />
            )
          }
        >
          <p data-testid="share-link-button-text" className="leading-6.5">
            {isCopied ? t('copied') : t('copy')}
          </p>
        </Button>
      </div>
      <p data-testid="share-options-text" className={`${subtitleStyles} pb-4`}>
        {t('options')}
      </p>
      <div className="flex flex-row space-x-3">
        <WhatsappShareButton
          data-testid="whatsapp-share-button"
          title={shareMessage}
          separator=""
          url={offerLink}
        >
          <div className={buttonStyles}>{t('whatsapp')}</div>
        </WhatsappShareButton>
        <EmailShareButton
          data-testid="email-share-button"
          subject={shareSubject}
          body={shareMessage}
          separator=""
          url={offerLink}
        >
          <div className={buttonStyles}>{t('email')}</div>
        </EmailShareButton>
        {teamsLink('hidden md:block')}
      </div>
      {teamsLink('w-max block  md:hidden mt-4')}
    </div>
  );
}
